module.exports = __webpack_public_path__ + "img/t1-2.d1741800.svg";